<template>
  <router-view />
</template>

<script>

export default {
  name: 'DashboardWrapper'
}
</script>
